import { useEffect, useRef, useState } from "react";
import { MessageSquareText, Phone, Mail, X } from "lucide-react";
import { SMS_URL, CALL_URL, EMAIL, PHONE_DISPLAY } from "../data";

export const ContactPill = () => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const el = ref.current;
    let tx = 0, ty = 0, cx = 0, cy = 0, raf;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      const mx = e.clientX - (r.left + r.width / 2);
      const my = e.clientY - (r.top + r.height / 2);
      const d = Math.hypot(mx, my), radius = 140;
      if (d < radius) {
        const pull = (1 - d / radius) * 0.35;
        tx = mx * pull; ty = my * pull;
      } else { tx = 0; ty = 0; }
    };
    window.addEventListener("pointermove", move, { passive: true });
    const tick = () => {
      cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
      el.style.transform = `translate(${cx.toFixed(2)}px,${cy.toFixed(2)}px)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => { window.removeEventListener("pointermove", move); cancelAnimationFrame(raf); };
  }, []);

  return (
    <>
      {open && (
        <div className="contact-menu" data-testid="contact-menu">
          <a href={SMS_URL} className="contact-opt" onClick={() => setOpen(false)} data-testid="contact-opt-text">
            <MessageSquareText size={17} /> <span>Text {PHONE_DISPLAY}</span>
          </a>
          <a href={CALL_URL} className="contact-opt" onClick={() => setOpen(false)} data-testid="contact-opt-call">
            <Phone size={17} /> <span>Call {PHONE_DISPLAY}</span>
          </a>
          <a href={"mailto:" + EMAIL} className="contact-opt" onClick={() => setOpen(false)} data-testid="contact-opt-email">
            <Mail size={17} /> <span>Email Lucho</span>
          </a>
        </div>
      )}
      <button className="wa" ref={ref} onClick={() => setOpen((o) => !o)} aria-label="Contact options" aria-expanded={open} data-testid="contact-pill">
        {open ? <X size={22} aria-hidden="true" /> : <MessageSquareText size={22} aria-hidden="true" />}
      </button>
    </>
  );
};
